module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.online) ? _c('div', {
    staticClass: "connexion-check"
  }, [_c('div', {
    staticClass: "middle"
  }, [_c('p', [_c('translate', [_vm._v("No internet connexion")])], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef537496"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/connexion-check.vue
// module id = 355
// module chunks = 1